import {
    CoreApiFilterObject,
    FILTER_TYPES,
} from '@/coreApi/filters/coreApiFilterObject'

const FILTER_ID_PAGE_FILTER = 'pf'

const coreApiPageFilters = [
    {
        title: 'Referrers',
        key: 'r',
        field_name: 'referer_domain',
        filter_type: 'multiple-select',
        data: [
            {
                label: 'Direct',
                value: 'site_direct',
            },
            {
                label: 'Home',
                value: 'site_internal_home',
            },
            {
                label: 'Internal',
                value: 'site_internal',
            },
            {
                label: 'Infinite Scroll',
                value: 'site_internal_infinite_scroll',
            },
            {
                label: 'Google Organic',
                value: 'search_google_organic',
            },
            {
                label: 'Google Amp',
                value: 'search_google_amp',
            },
            {
                label: 'Google News',
                value: 'search_google_new',
            },
            {
                label: 'Google CPC',
                value: 'search_google_cpc',
            },
            {
                label: 'Google Discover',
                value: 'search_google_discover',
            },
            {
                label: 'Facebook',
                value: 'social_facebook',
            },
            {
                label: 'Facebook Instance Article',
                value: 'social_facebook_instant_article',
            },
            {
                label: 'Instagram',
                value: 'social_instagram_referrer',
            },
            {
                label: 'Twitter',
                value: 'social_twitter_referrer',
            },
            {
                label: 'Hurriyet',
                value: 'hurriyet',
            },
            {
                label: 'Milliyet',
                value: 'milliyet',
            },
            {
                label: 'Sabah',
                value: 'sabah',
            },
            {
                label: 'gazeteler.com',
                value: 'gazeteler.com',
            },
            {
                label: 'gazetekeyfi.com',
                value: 'gazetekeyfi',
            },
            {
                label: 'Yandex',
                value: 'yandex',
            },
            {
                label: 'Yahoo',
                value: 'yahoo',
            },
            {
                label: 'Sanalbasin',
                value: 'sanalbasin',
            },
            {
                label: 'f5haber.com',
                value: 'f5haber.com',
            },
            {
                label: 'eksisozluk.com',
                value: 'eksisozluk.com',
            },
            {
                label: 'Bundle',
                value: 'bundle',
            },
        ],
    },
    {
        title: 'Source Referrers',
        key: 'ord',
        field_name: 'origin_referer_domain',
        filter_type: 'multiple-select',
        data: [
            {
                label: 'Direct',
                value: 'site_direct',
            },
            {
                label: 'Google Organic',
                value: 'search_google_organic',
            },
            {
                label: 'Google Amp',
                value: 'search_google_amp',
            },
            {
                label: 'Google News',
                value: 'search_google_new',
            },
            {
                label: 'Google CPC',
                value: 'search_google_cpc',
            },
            {
                label: 'Google Discover',
                value: 'search_google_discover',
            },
            {
                label: 'Facebook',
                value: 'social_facebook',
            },
            {
                label: 'Facebook Instance Article',
                value: 'social_facebook_instant_article',
            },
            {
                label: 'Instagram',
                value: 'social_instagram_referrer',
            },
            {
                label: 'Twitter',
                value: 'social_twitter_referrer',
            },
            {
                label: 'Hurriyet',
                value: 'hurriyet',
            },
            {
                label: 'Milliyet',
                value: 'milliyet',
            },
            {
                label: 'Sabah',
                value: 'sabah',
            },
            {
                label: 'gazeteler.com',
                value: 'gazeteler.com',
            },
            {
                label: 'gazetekeyfi.com',
                value: 'gazetekeyfi',
            },
            {
                label: 'Yandex',
                value: 'yandex',
            },
            {
                label: 'Yahoo',
                value: 'yahoo',
            },
            {
                label: 'Sanalbasin',
                value: 'sanalbasin',
            },
            {
                label: 'f5haber.com',
                value: 'f5haber.com',
            },
            {
                label: 'eksisozluk.com',
                value: 'eksisozluk.com',
            },
            {
                label: 'Bundle',
                value: 'bundle',
            },
        ],
    },
    {
        title: 'UTM Referrers',
        key: 'ur',
        field_name: 'referer_utm',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'bundle',
            'email',
            'f5haber',
            'facebook',
            'haberler.com',
            'gazetekeyfi',
            'gazeteoku',
            'google',
            'guncelhaberler',
            'webpush',
            't.co',
            'taboola',
        ],
    },
    {
        title: 'UTM Source Referrers',
        key: 'usr',
        field_name: 'origin_referer_utm',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'bundle',
            'email',
            'f5haber',
            'facebook',
            'haberler.com',
            'gazetekeyfi',
            'gazeteoku',
            'google',
            'guncelhaberler',
            'webpush',
            't.co',
            'taboola',
        ],
    },
    {
        title: 'Devices',
        key: 'd',
        field_name: 'device',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Desktop',
                value: 'desktop',
            },
            {
                label: 'Mobile',
                value: 'mobile',
            },
            {
                label: 'Tablet',
                value: 'tablet',
            },
        ],
    },
    {
        title: 'Sources',
        key: 's',
        field_name: 'source',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Web',
                value: 'web',
            },
            {
                label: 'Amp',
                value: 'amp',
            },
            {
                label: 'Instance Article',
                value: 'ia',
            },
            {
                label: 'Android App',
                value: 'androidApp',
            },
            {
                label: 'IOS App',
                value: 'iosApp',
            },
        ],
    },
    {
        title: 'Domains',
        key: 'ds',
        field_name: 'page_domains',
        filter_type: 'checkbox',
        data: [
            {
                label: 'www.cnnturk.com',
                value: 'www.cnnturk.com',
            },
            {
                label: 'secim.cnnturk.com',
                value: 'secim.cnnturk.com',
            },
        ],
    },
    {
        title: 'Categories',
        key: 'c',
        field_name: 'breadcrumb_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'Astroloji', value: 'astroloji' },
            { label: 'Borsa', value: 'borsa' },
            { label: 'Dünya', value: 'dünya' },
            { label: 'Eğitim', value: 'eğitim' },
            { label: 'Ekonomi', value: 'ekonomi' },
            { label: 'Kültür Sanat', value: 'kültür sanat' },
            { label: 'Magazin', value: 'magazin' },
            { label: 'Otomobil', value: 'otomobil' },
            { label: 'Ramazan', value: 'ramazan' },
            { label: 'Sağlık', value: 'sağlık' },
            { label: 'Seyahat', value: 'seyahat' },
            { label: 'Son Dakika', value: 'son dakika' },
            { label: 'Spor', value: 'spor' },
            { label: 'Teknoloji', value: 'teknoloji' },
            { label: 'Tüm Haberler', value: 'tüm haberler' },
            { label: 'Türkiye', value: 'türkiye' },
            { label: 'TV Programları', value: 'tv programları' },
            { label: 'Yaşam', value: 'yaşam' },
            { label: 'Yazarlar', value: 'yazarlar' },
            { label: 'Yerel Haberler', value: 'yerel haberler' },
        ],
    },
    {
        title: 'Authors',
        key: 'a',
        field_name: 'author_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'Afife Selen Selçuk', value: 'afife selen selçuk' },
            { label: 'Ahmet Hakan', value: 'ahmet hakan' },
            { label: 'Ahu Özyurt', value: 'ahu özyurt' },
            { label: 'Akif Beki', value: 'akif beki' },
            { label: 'Alpaslan Akkuş', value: 'alpaslan akkuş' },
            { label: 'Arif Kalem', value: 'arif kalem' },
            { label: 'Aslı Öymen', value: 'aslı öymen' },
            { label: 'Ahmet Kemal Şenpolat', value: 'ahmet kemal şenpolat' },
            { label: 'Ayşe Yonca Baltaoğlu', value: 'ayşe yonca baltaoğlu' },
            { label: 'Ayşegül Ekinci', value: 'ayşegül ekinci' },
            { label: 'Bahadır İşler', value: 'bahadır i̇şler' },
            { label: 'Begüm Dönmez', value: 'begüm dönmez' },
            { label: 'Beste Naz Köksal', value: 'beste naz köksal' },
            { label: 'Binnur Zaimler', value: 'binnur zaimler' },
            { label: 'Can Aydoğmuş', value: 'can aydoğmuş' },
            { label: 'Can Gürel', value: 'can gürel' },
            { label: 'Cansel Poyraz Akyol', value: 'cansel poyraz akyol' },
            { label: 'Cem Payaslı', value: 'cem payaslı' },
            { label: 'Cem Yılmaz', value: 'cem yılmaz' },
            { label: 'Ceren Alican', value: 'ceren alican' },
            { label: 'Ceylan Adanalı Kabadayıoğlu', value: 'ceylan adanalı kabadayıoğlu' },
            { label: 'Çiğdem Öztabak', value: 'çiğdem öztabak' },
            { label: 'Cüneyt Özdemir', value: 'cüneyt özdemir' },
            { label: 'Damla Doğan', value: 'damla doğan' },
            { label: 'Defne İnce', value: 'defne i̇nce' },
            { label: 'Deniz Alphan', value: 'deniz alphan' },
            { label: 'Deniz Bayramoğlu', value: 'deniz bayramoğlu' },
            { label: 'Derya Uludüz', value: 'derya uludüz' },
            { label: 'Dilay Ağaoğlu', value: 'dilay ağaoğlu' },
            { label: 'Duygu Merzifonluoğlu', value: 'duygu merzifonluoğlu' },
            { label: 'Emin Çapa', value: 'emin çapa' },
            { label: 'Emine Munyar', value: 'emine munyar' },
            { label: 'Emrah Ceylan', value: 'emrah ceylan' },
            { label: 'Emre Alkin', value: 'emre alkin' },
            { label: 'Emre Tilev', value: 'emre tilev' },
            { label: 'Erdem Aydın', value: 'erdem aydın' },
            { label: 'Erhan Merttürk', value: 'erhan merttürk' },
            { label: 'Esra Öz', value: 'esra öz' },
            { label: 'Fatoş Karahasan', value: 'fatoş karahasan' },
            { label: 'Fem Bozdağ', value: 'fem bozdağ' },
            { label: 'Ferhat Boratav', value: 'ferhat boratav' },
            { label: 'Fevzi Özgönül', value: 'fevzi özgönül' },
            { label: 'Fırat Öklü', value: 'fırat öklü' },
            { label: 'Gökhan İlker', value: 'gökhan i̇lker' },
            { label: 'Göksel Göksu', value: 'göksel göksu' },
            { label: 'Hakan Çelik', value: 'hakan çelik' },
            { label: 'Hande Atay Alam', value: 'hande atay alam' },
            { label: 'Hande Fırat', value: 'hande fırat' },
            { label: 'Haymi Behar', value: 'haymi behar' },
            { label: 'İdris Arıkan', value: 'i̇dris arıkan' },
            { label: 'Irmak Atak', value: 'irmak atak' },
            { label: 'Kıvanç Ünal', value: 'kıvanç ünal' },
            { label: 'Levent Kurnaz', value: 'levent kurnaz' },
            { label: 'Mehmet Ali Kantarcı', value: 'mehmet ali kantarcı' },
            { label: 'Mehmet Emin Güneş', value: 'mehmet emin güneş' },
            { label: 'Melis Danişmend', value: 'melis danişmend' },
            { label: 'Mete Sohtaoğlu', value: 'mete sohtaoğlu' },
            { label: 'Metin Güneş', value: 'metin güneş' },
            { label: 'Mine Ayman', value: 'mine ayman' },
            { label: 'Miray Öncü', value: 'miray öncü' },
            { label: 'Mithat Bülent Özmen', value: 'mithat bülent özmen' },
            { label: 'Murat Erdör', value: 'murat erdör' },
            { label: 'Murat Ferman', value: 'murat ferman' },
            { label: 'Murat Pazarbaşı', value: 'murat pazarbaşı' },
            { label: 'Mustafa Gündoğar', value: 'mustafa gündoğar' },
            { label: 'Nehir Babataş', value: 'nehir babataş' },
            { label: 'Nevşin Mengü', value: 'nevşin mengü' },
            { label: 'Nilgün Mıhçıoğlu', value: 'nilgün mıhçıoğlu' },
            { label: 'Nur Erdem Özeren', value: 'nur erdem özeren' },
            { label: 'Ozan Onat', value: 'ozan onat' },
            { label: 'Pınar Yılmazerler', value: 'pınar yılmazerler' },
            { label: 'Reha Erus', value: 'reha erus' },
            { label: 'Rıdvan Akar', value: 'rıdvan akar' },
            { label: 'Şafak Altun', value: 'şafak altun' },
            { label: 'Savaş Önemli', value: 'savaş önemli' },
            { label: 'Selda Öktem', value: 'selda öktem' },
            { label: 'Semiha Şahin', value: 'semiha şahin' },
            { label: 'Serap Aykut', value: 'serap aykut' },
            { label: 'Sercan Şipka', value: 'sercan şipka' },
            { label: 'Serhan Karasu', value: 'serhan karasu' },
            { label: 'Şirin Payzın', value: 'şirin payzın' },
            { label: 'Taha Akyol', value: 'taha akyol' },
            { label: 'Taha Özyürek', value: 'taha özyürek' },
            { label: 'Tarık Demirkan', value: 'tarık demirkan' },
            { label: 'Uğur Hakan Hacıoğlu', value: 'uğur hakan hacıoğlu' },
            { label: 'Uğur Önver', value: 'uğur önver' },
            { label: 'Umut Katırcı', value: 'umut katırcı' },
            { label: 'Utku Başar', value: 'utku başar' },
            { label: 'Vedat Karabulut', value: 'vedat karabulut' },
            { label: 'Yasemin Bilgel', value: 'yasemin bilgel' },
            { label: 'Yasemin Merih Alparslan', value: 'yasemin merih alparslan' },
            { label: 'Yonca Özge', value: 'yonca özge' },
            { label: 'Yüce Zerey', value: 'yüce zerey' },
        ],
    },
    {
        title: 'Editors',
        key: 'ed',
        field_name: 'author_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'adnanp', value: 'adnanp' },
            { label: 'afifejale', value: 'afifejale' },
            { label: 'ajdapekkan', value: 'ajdapekkan' },
            { label: 'alicanspor', value: 'alicanspor' },
            { label: 'aysenur.hakalan', value: 'aysenur.hakalan' },
            { label: 'bilgesenel', value: 'bilgesenel' },
            { label: 'btopbas', value: 'btopbas' },
            { label: 'buse.gungor', value: 'buse.gungor' },
            { label: 'candoker', value: 'candoker' },
            { label: 'celil', value: 'celil' },
            { label: 'cem', value: 'cem' },
            { label: 'ceyhan.unal', value: 'ceyhan.unal' },
            { label: 'cgodek', value: 'cgodek' },
            { label: 'cigdemerdin', value: 'cigdemerdin' },
            { label: 'CNN TÜRK', value: 'CNN TÜRK' },
            { label: 'denizhan', value: 'denizhan' },
            { label: 'dunyatas', value: 'dunyatas' },
            { label: 'eertem', value: 'eertem' },
            { label: 'ekoc', value: 'ekoc' },
            { label: 'enisbasak', value: 'enisbasak' },
            { label: 'esoysal', value: 'esoysal' },
            { label: 'esravideo', value: 'esravideo' },
            { label: 'fhazar', value: 'fhazar' },
            { label: 'galeano', value: 'galeano' },
            { label: 'gpamuk', value: 'gpamuk' },
            { label: 'gulaysubatli', value: 'gulaysubatli' },
            { label: 'gultenm', value: 'gultenm' },
            { label: 'hakan.kamburoglu', value: 'hakan.kamburoglu' },
            { label: 'hakanozbek', value: 'hakanozbek' },
            { label: 'hasal', value: 'hasal' },
            { label: 'hkoyuncu', value: 'hkoyuncu' },
            { label: 'ipinar', value: 'ipinar' },
            { label: 'iremkusoglu', value: 'iremkusoglu' },
            { label: 'isacakir', value: 'isacakir' },
            { label: 'keremhancer', value: 'keremhancer' },
            { label: 'leguin', value: 'leguin' },
            { label: 'mahmuttezcan', value: 'mahmuttezcan' },
            { label: 'maydin', value: 'maydin' },
            { label: 'mcan', value: 'mcan' },
            { label: 'mecit.celebi', value: 'mecit.celebi' },
            { label: 'merteski', value: 'merteski' },
            { label: 'minceoglu', value: 'minceoglu' },
            { label: 'mstezcanoglu', value: 'mstezcanoglu' },
            { label: 'mustafab', value: 'mustafab' },
            { label: 'nakbas', value: 'nakbas' },
            { label: 'nimetkirac', value: 'nimetkirac' },
            { label: 'oaydos', value: 'oaydos' },
            { label: 'ocetin', value: 'ocetin' },
            { label: 'oguzhanseo', value: 'oguzhanseo' },
            { label: 'omeryilmaz', value: 'omeryilmaz' },
            { label: 'ozlemcitci', value: 'ozlemcitci' },
            { label: 'sedatoguz', value: 'sedatoguz' },
            { label: 'selcuk.turan', value: 'selcuk.turan' },
            { label: 'seyda.aydin', value: 'seyda.aydin' },
            { label: 'stajyer', value: 'stajyer' },
            { label: 'suleymana', value: 'suleymana' },
            { label: 'syuzuk', value: 'syuzuk' },
            { label: 'teknoloji', value: 'teknoloji' },
            { label: 'ttopcu', value: 'ttopcu' },
            { label: 'ukatirci', value: 'ukatirci' },
            { label: 'universite', value: 'universite' },
            { label: 'utkubas', value: 'utkubas' },
            { label: 'vahapspor', value: 'vahapspor' },
            { label: 'volkant', value: 'volkant' },
            { label: 'www.cnnturk.com', value: 'www.cnnturk.com' },
            { label: 'yasar.can', value: 'yasar.can' },
            { label: 'yaseminates', value: 'yaseminates' },
            { label: 'yaseming', value: 'yaseming' },
            { label: 'yunusemre', value: 'yunusemre' },
            { label: 'zbozkurt', value: 'zbozkurt' },
            { label: 'zekimuren', value: 'zekimuren' },
        ],
    },
    {
        title: 'User Type',
        key: 'ut',
        field_name: 'user_types',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Anonymous',
                value: 'anonymous',
            },
            {
                label: 'Paid',
                value: 'paid',
            },
            {
                label: 'Logged In',
                value: 'loggedin',
            },
        ],
    },
    {
        title: 'Keywords',
        key: 'kw',
        field_name: 'keywords',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'seohaber',
        ],
    },
    {
        title: 'Keywords Exclude',
        key: 'kwn',
        field_name: 'not_keywords',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'seohaber',
        ],
    },
    {
        title: 'Search',
        key: 'srch',
        field_name: 'search_include',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            '404 hata sayfası',
        ],
    },
]

export const coreApiPageFilterCnnturkObject = new CoreApiFilterObject(FILTER_ID_PAGE_FILTER, FILTER_TYPES.VALUES, coreApiPageFilters)
